export const THEMES = {
    light: {
        colors: {
            primary: "#1976D2",
            secondary: "#E7F3FD",
            background: "#FFFFFF",
            surface: "#EDEEF0", // sidebars, menus
            "surface-bright": "#FFFFFF", // floating panels
            "surface-light": "#F5F5F5", // toolbars
            "surface-variant": "#DDDDDD", // tooltip background
            "on-surface-variant": "#141516", // tooltip text
            "secondary-darken-1": "#018786", // overlay scrim
            "primary-text": "#141516",
            "secondary-text": "#757575",
            "helper-text": "#B9B9B9",
            "button-text": "#FFFFFF",
            border: "#C9CBCE",
            success: "#4CAF50",
            error: "#F44336",
            info: "#2196F3",
            warning: "#FFC107",
        },
    },
    dark: {
        dark: true,
        colors: {
            primary: "#ABD9FF",
            secondary: "#3C3C3C",
            background: "#141516",
            surface: "#343536", // sidebars, menus
            "surface-bright": "#141516", // floating panels
            "surface-light": "#272727", // toolbars
            "surface-variant": "#454545", // tooltip background
            "on-surface-variant": "#FFFFFF", // tooltip text
            "secondary-darken-1": "#0A0A0B", // overlay scrim
            "primary-text": "#FFFFFF",
            "secondary-text": "#CACACA",
            "helper-text": "#757575",
            "button-text": "#141516",
            border: "#C9CBCE",
            success: "#66BB6A",
            error: "#EF5350",
            info: "#42A5F5",
            warning: "#FFB74D",
        },
    },
};
